import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { UploadFilesModel } from '../../helpers/objects/dto/upload-files/upload-files-model';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  public upload(file: File): Observable<UploadFilesModel> {
    const formData: FormData = new FormData();
    formData.append('filename', file);

    return this.http
      .post<any>(this.appConfig.api + 'files/' + this.appConfig.apiPartnershipId, formData)
      .pipe(map((response) => response.body as UploadFilesModel));
  }

  public getArchiveId(guidFile: any, featureName?: any): Observable<any> {
    const body = {
      featureName: featureName,
      guid: guidFile
    };
    return this.http.post<any>(this.appConfig.api + 'backoffice/documents-archive/' + this.appConfig.apiPartnershipId, body);
  }
}
